<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="factory.pkId ? '编辑' : '新建'"
      width="600px"
      @close="$reset('form')">
    <el-form
        ref="form"
        v-loading="contentLoading"
        :model="factory"
        :rules="ruleValidate"
        class="form"
        label-width="80px">
      <el-form-item v-if="factory.pkId" label="工厂编号">
        <el-input v-model="factory.factoryNo" disabled/>
      </el-form-item>
      <el-form-item label="工厂名称" prop="factoryName">
        <el-input v-model="factory.factoryName" placeholder="请输入工厂名称"/>
      </el-form-item>
      <el-form-item label="工厂简称">
        <el-input v-model="factory.shortName" placeholder="请输入工厂简称"/>
      </el-form-item>
      <el-form-item label="工厂地址">
        <el-input v-model="factory.address" placeholder="请输入工厂地址"/>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="handleSubmit">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  export default {
    name: "FactoryEdit",
    data() {
      return {
        dialogVisible: false,
        submitLoading: false,
        contentLoading: false,
        factory: {
          pkId: 0,
          factoryNo: "",
          factoryName: "",
          shortName: "",
          address: "",
        },
        ruleValidate: {
          factoryName: { required: true, message: "请输入工厂名称", trigger: "blur" },
        },
      };
    },
    methods: {
      open(row) {
        this.dialogVisible = true;
        if (row) {
          this.factory.pkId = row.pkId;
          this.getData();
        }
      },

      getData() {
        this.contentLoading = true;
        this.$http
          .get("basic", `factorys/${this.factory.pkId}`)
          .then((resp) => {
            this.contentLoading = false;
            if (resp.success) {
              this.factory = Object.assign(this.factory, resp.data);
            }
          })
          .catch(() => {
            this.contentLoading = false;
          });
      },

      handleSubmit() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .save("basic", "factorys", this.factory)
              .then((resp) => {
                this.submitLoading = false;
                if (resp.success) {
                  if (this.factory.pkId) {
                    this.$emit("save-success");
                    this.$message.success("编辑成功");
                  } else {
                    this.$emit("save-success");
                    this.$message.success("添加成功");
                  }
                  this.dialogVisible = false;
                }
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>
